import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { detectMobile } from './detectMobile';

// Detect mobile devices and handle route-based restrictions
const isRestricted = detectMobile(window.location.pathname);

if (!isRestricted) {
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(
        <React.StrictMode>
            <App />
        </React.StrictMode>
    );
}

// Measure performance
reportWebVitals();
